import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { RelatedAsset } from '@app/core/model/entities/asset/asset';
import { Lease } from '@app/core/model/entities/asset/lease';
import {
  OrganizationLeaseCreateModalComponent
} from '@app/features/main/views/organization-occupants/modals/organization-lease-create-modal/organization-lease-create-modal.component';
import { isNullOrEmpty } from '@app/shared/extra/utils';
import { TranslateService } from '@ngx-translate/core';
import { FieldService } from '@services/field.service';
import { from } from 'rxjs';
import { filter, map, mergeMap, toArray } from 'rxjs/operators';

@Component({
    templateUrl: './organization-lease-renew-modal.component.html',
    styleUrl: '../../../../../../shared/components/form-builder/sections/create-modal.component.scss',
    standalone: false
})
export class OrganizationLeaseRenewModalComponent extends OrganizationLeaseCreateModalComponent {
  private leaseToRenew = inject<{ leaseToRenew: Lease }>(MAT_DIALOG_DATA).leaseToRenew;
  protected translate = inject(TranslateService);
  private fieldService = inject(FieldService);

  constructor() {
    super();
    // All fields with a value in the lease to renew
    const checkExistingFields = Object.entries(this.leaseToRenew)
      .filter(([_, value]) => !isNullOrEmpty(value))
      .map(([key]) => key)
      .concat(Object.keys(this.leaseToRenew.properties));

    this.missingRequiredFields$ = this.fieldService.getFields('ALL', EntityTypeEnum.LEASE).pipe(
      mergeMap(fields => from(fields)),
      filter(field => (!field.computed || field.hasAlias) && checkExistingFields.includes(field.alias)),
      // Keep remaining fields without sufficient user permissions
      filter(({alias}) => !this.accessManager.hasFieldWriteAccess(alias, EntityTypeEnum.LEASE)),
      map(({code, label}) => ({code, label})),
      toArray(),
      takeUntilDestroyed()
    );
  }

  /**
   * Init lease form.
   */
  public ngOnInit(): void {
    super.ngOnInit();

    // Set form value for the Occupant's name and disable input
    this.leaseForm.controls.occupant.setValue(this.leaseToRenew.occupant.toRelatedOccupant());
    this.leaseForm.controls.occupant.disable();

    this.leaseForm.controls.asset.setValue(
      new RelatedAsset(this.leaseToRenew.computedProperties.asset)
    );
  }
}
